import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Link, useParams } from 'react-router-dom'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { useEffect, useRef } from 'react'
import { ClassDetails } from './ClassDetails'
import HelmetMeta from '../../layouts/HelmetMeta'

export default function ClassesDubai () {
  const { article } = useParams()
  const readingRef = useRef(null)

  useEffect(() => {
    if (article) {
      setTimeout(() => readingRef.current.scrollIntoView(), 100)
    }
  }, [article])

  return (
    <Container>
      <HelmetMeta
        title='EMIRATES SKATING CLUB | Ice Skating Classes in Dubai'
        description='Whether you are looking to perfect your technique or simply enjoy a leisurely ice skate, join Emirates Skating Club classes in Dubai!'
      />
      <Box sx={{ pt: 14, pb: 2 }}>
        <Typography variant='h5' component='h1'>SCHEDULE OF CLASSES AT ESC DUBAI</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Typography variant='subtitle2'>
            At the Emirates Skating Club in Dubai, ice-skating offers a unique blend of elegance and excitement amidst
            the desert heat. Nestled in the heart of the city, this state-of-the-art facility features a pristine ice
            rink where skaters of all levels can glide gracefully while enjoying the cool, refreshing atmosphere. With its focus on both recreational and competitive skating, the club provides an inviting environment for enthusiasts to hone their skills, take lessons from experienced coaches, or simply enjoy a fun day on the ice with family and friends.
          </Typography>
          <Box sx={{ mt: 2 }} ref={readingRef}>
            <Button variant='contained' component={Link} to='/team/dubai/ice-team' target='_blank'>Coaches</Button>
            <Button variant='contained' sx={{ ml: 2 }} component={Link} to='/locations/dubai' target='_blank'>Location</Button>
          </Box>
        </Grid>
        <ClassDetails />
      </Grid>
    </Container>
  )
}
